import { render, staticRenderFns } from "./RsaRiepilogoAccessiAdiListPageOspite.vue?vue&type=template&id=2641c1cf"
import script from "./RsaRiepilogoAccessiAdiListPageOspite.vue?vue&type=script&lang=js"
export * from "./RsaRiepilogoAccessiAdiListPageOspite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports